import Styled from 'styled-components';

import { media } from '../../../../lib/StyledComponents';

export const VerTaskCta = Styled.div`
  right: 1.5em;
  line-height: 0;
  display: flex;
  align-items: center;

  ${media.medium`
    right: 2em;
  `}
`;
